<template lang="html">
  <div>
    <div class="regiterationLayout text-xs-center">
      <h1 style="font-weight: 900; font-size:2.5em">สแกนบัตรลงคะแนน</h1>
      <v-layout row wrap class="mt-4">
        <v-flex xs12 sm2>
          <h2 >ค้นหา</h2>
        </v-flex>
        <v-flex xs12 sm8>
          <v-text-field autofocus @keyup.enter="submit('/vote/w')" v-model="qrcodefullid" placeholder="สแกนบัตรลงคะแนนที่นี่" autocomplete hint="กรณีท่านต้องป้อนข้อมูลผ่านคีย์บอร์ด กรุณากรอกตัวเลขให้ครบถ้วน"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6>
          <v-btn round @click="submit('/vote/w')" color="primary">Submit</v-btn>
        </v-flex>
        <v-flex xs12 sm6>
          <v-btn @click="reset()" round color="primary">Reset</v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      selectedItem: {},
      qrcodefullid: null,
      memberInfo: [],
      showInfo: false,
      nametest: []
    }
  },
  methods: {
    toPage (url) {
      this.$router.push(url)
    },
    submit (url) {
      // var item = this.qrcodefullid
      // console.log(item)
      // this.nametest.push(this.qrcodefullid.slice(0, this.qrcodefullid.length - 4))
      // this.nametest.push(this.qrcodefullid.slice(-4))
      // var memberid = item.slice(0, 10)
      // var agendaid = item.slice(10, 14)
      // this.testmemberid = memberid
      // this.testagendaid = agendaid
      // --------------------------------------------------------------------------
      // localStorage.setItem('content', this.nametest)
      // localStorage.setItem('itemAgendaid', this.testagendaid)
      if (url === '/vote/w') {
        // var newWindow = window.open(url + this.qrcodefullid, '_blank')
        // console.log(newWindow)
        this.$router.push(url + this.qrcodefullid)
        // setTimeout(function () { window.location.reload() }, 10)
      } else {
        this.$router.push(url + this.qrcodefullid)
      }
      // #after submit clear value
      this.qrcodefullid = ''

      // console.log(memberid)
      // console.log(agendaid)
      // var test = { 'memberid': this.qrcodefullid }
      // var data = { 'memberid': this.qrcodefullid }

      // this.axios.post('http://localhost:5000' + '/showScanMember', data).then((response) => {
      //   var result = response.data
      //   console.log(result)
      //   this.memberInfo = result
      //   $('input').blur()
      //   if (response.status === 200) {
      //     if (result.status === 'success') {
      //       this.$swal('สำเร็จ !', 'ทำรายการสำเร็จ', 'success')
      //     } else {
      //       this.$swal('ผิดพลาด !', 'ไม่มีข้อมูลกรุณากรอกข้อมูลใหม่', 'error')
      //     }
      //   }
      // })
    },
    reset () {
      this.qrcodefullid = ''
    }
  },
  mounted () {
  }
}
</script>

<style lang="css" scoped>
.regiterationLayout{
  /* border: solid;  */
  width : 70%;
  height: 70%;
  margin: 10% auto;
  /* text-align: center; */
}

.formInfo{
  margin-top:10%;
  text-align: left;
}
.infoDiv{
  border: 2px solid #ccc;
  border-radius: 1em;
  padding: 2em;
}
.pd5{
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/QRScanerWeb.vue